class TournaInfoCarousel extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-slide]')];
    this.dots = [...this.querySelectorAll('[data-dot]')];
    this.prevBtn = this.querySelector('[data-prev]');
    this.nextBtn = this.querySelector('[data-next]');
    this.index = 0;
    this.timer = null;
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.touchDeltaX = 0;
    this.isSwiping = false;
    this.didSwipe = false;

    if (this.slides.length < 2) return;

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.goTo(Number(dot.dataset.dot));
        this.start();
      });
    });

    this.prevBtn?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.goTo(this.index - 1);
      this.start();
    });

    this.nextBtn?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.goTo(this.index + 1);
      this.start();
    });

    this.slides.forEach((slide) => {
      slide.addEventListener('click', (event) => {
        if (this.didSwipe) {
          event.preventDefault();
          event.stopPropagation();
          this.didSwipe = false;
        }
      });
    });

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('touchstart', this.onTouchStart, { passive: true });
    this.addEventListener('touchmove', this.onTouchMove, { passive: true });
    this.addEventListener('touchend', this.onTouchEnd, { passive: true });
    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  get autoplay() {
    return this.dataset.autoplay !== 'false';
  }

  get speed() {
    const value = parseFloat(getComputedStyle(this).getPropertyValue('--tourna-info-speed'));
    return Number.isFinite(value) ? value * 1000 : 6000;
  }

  onTouchStart = (event) => {
    if (!event.touches?.length) return;
    this.touchStartX = event.touches[0].clientX;
    this.touchStartY = event.touches[0].clientY;
    this.touchDeltaX = 0;
    this.isSwiping = false;
    this.stop();
  };

  onTouchMove = (event) => {
    if (!event.touches?.length) return;
    const deltaX = event.touches[0].clientX - this.touchStartX;
    const deltaY = event.touches[0].clientY - this.touchStartY;
    if (!this.isSwiping && Math.abs(deltaX) > 10 && Math.abs(deltaX) > Math.abs(deltaY)) {
      this.isSwiping = true;
    }
    if (this.isSwiping) this.touchDeltaX = deltaX;
  };

  onTouchEnd = () => {
    if (this.isSwiping && Math.abs(this.touchDeltaX) > 50) {
      this.didSwipe = true;
      this.goTo(this.touchDeltaX < 0 ? this.index + 1 : this.index - 1);
    }
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.touchDeltaX = 0;
    this.isSwiping = false;
    this.start();
  };

  goTo(next) {
    const current = this.slides[this.index];
    const currentDot = this.dots[this.index];
    current?.classList.remove('is-active');
    current?.setAttribute('aria-hidden', 'true');
    current?.setAttribute('tabindex', '-1');
    currentDot?.classList.remove('is-active');
    currentDot?.removeAttribute('aria-current');

    this.index = (next + this.slides.length) % this.slides.length;

    const active = this.slides[this.index];
    const activeDot = this.dots[this.index];
    active?.classList.add('is-active');
    active?.removeAttribute('aria-hidden');
    active?.removeAttribute('tabindex');
    activeDot?.classList.add('is-active');
    activeDot?.setAttribute('aria-current', 'true');
    this.syncVideos();
  }

  syncVideos() {
    this.querySelectorAll('[data-info-video]').forEach((video) => {
      const onActiveSlide = video.closest('[data-slide]')?.classList.contains('is-active');
      if (onActiveSlide) {
        video.play().catch(() => {});
      } else {
        video.pause();
        video.currentTime = 0;
      }
    });
  }

  start() {
    if (!this.autoplay) return;
    this.stop();
    this.timer = window.setInterval(() => this.goTo(this.index + 1), this.speed);
  }

  stop() {
    if (this.timer) window.clearInterval(this.timer);
    this.timer = null;
  }
}

if (!customElements.get('tourna-info-carousel')) {
  customElements.define('tourna-info-carousel', TournaInfoCarousel);
}
